export default __webpack_public_path__ + "static/media/space4.c38898dd.png";